import {Component} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-team-transaction-permission-modal',
  templateUrl: './team-transaction-permission-modal.component.html',
  styleUrl: './team-transaction-permission-modal.component.scss'
})
export class TeamTransactionPermissionModalComponent {

  constructor(
    protected dialogRef: MatDialogRef<TeamTransactionPermissionModalComponent>,
  ) {
  }

  turnOn(): void {
    this.dialogRef.close(true);
  }

  turnOff(): void {
    this.dialogRef.close(false);
  }
}
